import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/territories/$territoryId/')({
  beforeLoad: ({ context, params }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('territories:list')) {
      throw redirect({
        params: { territoryId: params.territoryId },
        to: '/settings/territories/$territoryId/locations',
      });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/territories/pages/territory-general-page')),
  staticData: { titleKey: 'general' },
});
